var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "KButton",
    _vm._g(
      {
        attrs: {
          color: _vm.color,
          disabled: _vm.disabled,
          appearance: _vm.appearance,
          appearanceOverrides: _vm.appearanceOverrides,
          type: _vm.buttonType,
          "aria-label": _vm.computedAriaLabel,
          text: "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "menu",
              fn: function () {
                return [_vm._t("menu")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      _vm.$listeners
    ),
    [
      _vm.tooltip
        ? _c(
            "UiTooltip",
            {
              attrs: {
                zIndex: 24,
                openOn: "hover",
                position: _vm.tooltipPosition,
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.tooltip) + "\n  ")]
          )
        : _vm._e(),
      _c("KIcon", {
        style: _vm.iconStyles,
        attrs: { icon: _vm.icon, color: _vm.color },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }